(function () {
  'use strict';

  function ProductQuickView(section) {
    this.section = section;
    this.popup = section.querySelector('[data-product-quickview-popup]');
    this.productMetaMap = {};
    this._modalKeydownAttached = false;
    this._boundModalKeydown = this._handleModalKeydown.bind(this);
    this._previewLastFocus = null;
    this._loading = false;

    var metaEl = section.querySelector('[data-product-quickview-meta]');
    if (metaEl && metaEl.textContent) {
      try {
        this.productMetaMap = JSON.parse(metaEl.textContent);
      } catch (e) {
        this.productMetaMap = {};
      }
    }

    if (this.popup) this.init();
  }

  ProductQuickView.prototype.getRoot = function () {
    if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) {
      return String(Theme.routes.cart_url).replace(/\/cart\/?$/, '');
    }
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
      return window.location.origin;
    }
    return '';
  };

  ProductQuickView.prototype.formatMoney = function (price) {
    if (price == null) return '';
    var num = typeof price === 'string' ? parseFloat(price, 10) : Number(price);
    if (isNaN(num)) return '';
    var isDecimalDollars =
      (typeof price === 'string' && price.indexOf('.') !== -1) ||
      (typeof price === 'number' && price !== Math.floor(price));
    var cents = isDecimalDollars ? Math.round(num * 100) : num;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  };

  ProductQuickView.prototype._imageUrlWithWidth = function (url, width) {
    if (!url || !String(url).trim()) return '';
    var u = String(url).replace(/&amp;/g, '&');
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  };

  ProductQuickView.prototype.parseHandleFromUrl = function (url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  };

  ProductQuickView.prototype._clearPreviewError = function () {
    if (!this.popup) return;
    var err = this.popup.querySelector('[data-preview-error]');
    var content = this.popup.querySelector('[data-preview-content]');
    if (err) {
      err.textContent = '';
      err.hidden = true;
    }
    if (content) content.hidden = false;
  };

  ProductQuickView.prototype._showPreviewError = function (msg) {
    if (!this.popup) return;
    var err = this.popup.querySelector('[data-preview-error]');
    var content = this.popup.querySelector('[data-preview-content]');
    if (err) {
      err.textContent = msg;
      err.hidden = false;
    }
    if (content) content.hidden = true;
  };

  ProductQuickView.prototype._resetPreviewDescriptionReadMore = function () {
    if (!this.popup) return;
    var desc = this.popup.querySelector('[data-preview-description]');
    var btn = this.popup.querySelector('[data-preview-read-more]');
    if (desc) desc.classList.remove('is-expanded');
    if (btn) {
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'Read more';
    }
  };

  ProductQuickView.prototype._setupPreviewDescriptionReadMore = function () {
    if (!this.popup) return;
    var desc = this.popup.querySelector('[data-preview-description]');
    var btn = this.popup.querySelector('[data-preview-read-more]');
    if (!desc || !btn) return;
    desc.classList.remove('is-expanded');
    var txt = (desc.textContent || '').replace(/\s/g, '');
    if (!txt) {
      btn.hidden = true;
      return;
    }
    var maxCollapsedPx = 120;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var needsMore = desc.scrollHeight > maxCollapsedPx + 10;
        btn.hidden = !needsMore;
        btn.textContent = 'Read more';
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  };

  ProductQuickView.prototype._attachModalKeydown = function () {
    if (this._modalKeydownAttached) return;
    document.addEventListener('keydown', this._boundModalKeydown);
    this._modalKeydownAttached = true;
  };

  ProductQuickView.prototype._detachModalKeydown = function () {
    if (!this._modalKeydownAttached) return;
    document.removeEventListener('keydown', this._boundModalKeydown);
    this._modalKeydownAttached = false;
  };

  ProductQuickView.prototype._handleModalKeydown = function (e) {
    if (!this.popup || this.popup.hasAttribute('hidden')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusables = this.popup.querySelectorAll(
      'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  ProductQuickView.prototype.close = function () {
    if (!this.popup) return;
    this._loading = false;
    this._resetPreviewDescriptionReadMore();
    this._setMediaLoading(false);
    var mainImg = this.popup.querySelector('[data-preview-main-img]');
    if (mainImg) {
      mainImg.hidden = true;
      mainImg.removeAttribute('src');
      mainImg.alt = '';
    }
    var thumbsWrap = this.popup.querySelector('[data-preview-thumbs]');
    if (thumbsWrap) thumbsWrap.innerHTML = '';
    this.popup.setAttribute('hidden', '');
    this.popup.setAttribute('aria-hidden', 'true');
    this._detachModalKeydown();
    document.body.style.overflow = '';
    var el = this._previewLastFocus;
    this._previewLastFocus = null;
    if (el && typeof el.focus === 'function') {
      try {
        el.focus();
      } catch (err) {}
    }
  };

  ProductQuickView.prototype._getCardImageSrc = function (triggerEl) {
    if (!triggerEl || !triggerEl.closest) return '';
    var card = triggerEl.closest('.badass-card');
    if (!card) return '';
    var cardImg = card.querySelector('.badass-card__image');
    if (!cardImg) return '';
    return cardImg.currentSrc || cardImg.src || cardImg.getAttribute('src') || '';
  };

  ProductQuickView.prototype._setMediaLoading = function (loading) {
    var wrap = this.popup && this.popup.querySelector('[data-preview-main-wrap]');
    var loader = this.popup && this.popup.querySelector('[data-preview-media-loading]');
    if (wrap) wrap.classList.toggle('is-loading', !!loading);
    if (loader) loader.setAttribute('aria-hidden', loading ? 'false' : 'true');
  };

  ProductQuickView.prototype._loadMainImage = function (src, alt) {
    var self = this;
    var mainImg = this.popup && this.popup.querySelector('[data-preview-main-img]');
    if (!mainImg) {
      this._setMediaLoading(false);
      return;
    }
    if (!src) {
      mainImg.hidden = true;
      mainImg.removeAttribute('src');
      mainImg.alt = '';
      this._setMediaLoading(false);
      return;
    }

    var finish = function (showImage) {
      if (showImage) {
        mainImg.hidden = false;
      } else {
        mainImg.hidden = true;
      }
      self._setMediaLoading(false);
    };

    if (mainImg.getAttribute('src') === src && mainImg.complete && mainImg.naturalWidth > 0) {
      mainImg.alt = alt || '';
      finish(true);
      return;
    }

    var onLoad = function () {
      mainImg.removeEventListener('load', onLoad);
      mainImg.removeEventListener('error', onError);
      mainImg.alt = alt || '';
      finish(true);
    };
    var onError = function () {
      mainImg.removeEventListener('load', onLoad);
      mainImg.removeEventListener('error', onError);
      finish(false);
    };

    mainImg.addEventListener('load', onLoad);
    mainImg.addEventListener('error', onError);
    mainImg.alt = alt || '';
    mainImg.src = src;
    if (mainImg.complete) {
      if (mainImg.naturalWidth > 0) onLoad();
      else onError();
    }
  };

  ProductQuickView.prototype._showPlaceholderImage = function (triggerEl) {
    var mainImg = this.popup && this.popup.querySelector('[data-preview-main-img]');
    if (!mainImg) return;
    var placeholderSrc = this._getCardImageSrc(triggerEl);
    if (!placeholderSrc) {
      mainImg.hidden = true;
      mainImg.removeAttribute('src');
      return;
    }
    mainImg.hidden = false;
    mainImg.removeAttribute('alt');
    mainImg.src = placeholderSrc;
  };

  ProductQuickView.prototype._fillPreviewPanel = function (prod, variantId) {
    var self = this;
    if (!this.popup) return;
    this._clearPreviewError();

    var v = null;
    (prod.variants || []).forEach(function (vr) {
      if (String(vr.id) === String(variantId)) v = vr;
    });
    if (!v && prod.variants && prod.variants.length) v = prod.variants[0];

    var titleEl = this.popup.querySelector('[data-preview-title]');
    if (titleEl) titleEl.textContent = prod.title || '';

    var priceEl = this.popup.querySelector('[data-preview-price]');
    var compareEl = this.popup.querySelector('[data-preview-compare]');
    if (priceEl && v) {
      var pNum = parseFloat(v.price);
      var cRaw = v.compare_at_price;
      var cNum = cRaw != null && cRaw !== '' ? parseFloat(cRaw) : NaN;
      priceEl.textContent = this.formatMoney(v.price);
      if (compareEl) {
        if (!isNaN(cNum) && !isNaN(pNum) && cNum > pNum) {
          compareEl.textContent = this.formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
    }

    var ratingEl = this.popup.querySelector('[data-preview-rating-text]');
    if (ratingEl) ratingEl.textContent = this.section.getAttribute('data-preview-rating-text') || '';

    var meta = {};
    if (prod.handle && this.productMetaMap && typeof this.productMetaMap === 'object') {
      meta = this.productMetaMap[prod.handle] || {};
    }
    var defBurn = (this.section.getAttribute('data-preview-spec-burn') || '60hr burn').trim();
    var defSize = (this.section.getAttribute('data-preview-spec-size') || '12oz').trim();
    var burnText = meta.burn != null && String(meta.burn).trim() !== '' ? String(meta.burn).trim() : defBurn;
    var sizeText = meta.size != null && String(meta.size).trim() !== '' ? String(meta.size).trim() : defSize;

    var burnRow = this.popup.querySelector('[data-preview-spec-burn-row]');
    var sizeRow = this.popup.querySelector('[data-preview-spec-size-row]');
    var burnEl = this.popup.querySelector('[data-preview-spec-burn]');
    var sizeEl = this.popup.querySelector('[data-preview-spec-size]');
    if (burnEl) burnEl.textContent = burnText;
    if (sizeEl) sizeEl.textContent = sizeText;
    if (burnRow) burnRow.style.display = burnText ? '' : 'none';
    if (sizeRow) sizeRow.style.display = sizeText ? '' : 'none';

    var descEl = this.popup.querySelector('[data-preview-description]');
    if (descEl) {
      if (prod.description) {
        descEl.innerHTML = prod.description;
      } else {
        descEl.innerHTML = '';
      }
    }
    this._setupPreviewDescriptionReadMore();

    var root = this.getRoot();
    var link = this.popup.querySelector('[data-preview-product-link]');
    if (link) {
      var path = prod.url || (prod.handle ? '/products/' + prod.handle : '#');
      link.href = (root || '') + path;
      var lbl = this.section.getAttribute('data-preview-btn-label');
      if (lbl) link.textContent = lbl;
    }

    function imgSrc(im, w) {
      if (!im) return '';
      var s = im.src || (typeof im === 'string' ? im : '');
      if (!s) return '';
      return self._imageUrlWithWidth(s, w);
    }

    var imgs = prod.images || [];
    if (!imgs.length && prod.featured_image) {
      var fe = prod.featured_image;
      var feSrc = typeof fe === 'string' ? fe : fe && fe.src ? fe.src : '';
      if (feSrc) imgs = [{ src: feSrc }];
    }
    var mainImg = this.popup.querySelector('[data-preview-main-img]');
    var thumbsWrap = this.popup.querySelector('[data-preview-thumbs]');
    var firstSrc = imgs.length ? imgSrc(imgs[0], 900) : '';
    this._loadMainImage(firstSrc, prod.title || '');
    if (thumbsWrap) {
      thumbsWrap.innerHTML = '';
      var maxT = Math.min(imgs.length, 6);
      for (var ti = 0; ti < maxT; ti++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className =
            'bundle-builder-popup__thumb bundle-builder-preview__thumb' +
            (idx === 0 ? ' bundle-builder-popup__thumb--active' : '');
          btn.setAttribute('aria-label', 'Show image ' + (idx + 1));
          btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
          var im = document.createElement('img');
          im.src = imgSrc(imgs[idx], 280);
          im.alt = '';
          im.loading = 'lazy';
          im.decoding = 'async';
          im.width = 122;
          im.height = 140;
          btn.appendChild(im);
          btn.addEventListener('click', function () {
            self._setMediaLoading(true);
            self._loadMainImage(imgSrc(imgs[idx], 900), prod.title || '');
            var all = thumbsWrap.querySelectorAll('.bundle-builder-popup__thumb');
            for (var k = 0; k < all.length; k++) {
              all[k].classList.remove('bundle-builder-popup__thumb--active');
              all[k].setAttribute('aria-selected', 'false');
            }
            btn.classList.add('bundle-builder-popup__thumb--active');
            btn.setAttribute('aria-selected', 'true');
          });
          thumbsWrap.appendChild(btn);
        })(ti);
      }
    }
  };

  ProductQuickView.prototype.openFromUrl = function (productUrl, triggerEl) {
    var self = this;
    if (!this.popup || this._loading) return;

    var handle = this.parseHandleFromUrl(productUrl);
    if (!handle) return;

    this._previewLastFocus = triggerEl || document.activeElement;
    this._clearPreviewError();
    this._resetPreviewDescriptionReadMore();

    var titleEl = this.popup.querySelector('[data-preview-title]');
    if (titleEl) titleEl.textContent = '';
    var priceEl = this.popup.querySelector('[data-preview-price]');
    if (priceEl) priceEl.textContent = '';
    var compareEl = this.popup.querySelector('[data-preview-compare]');
    if (compareEl) {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }
    var descEl = this.popup.querySelector('[data-preview-description]');
    if (descEl) descEl.innerHTML = '';
    var thumbsWrap = this.popup.querySelector('[data-preview-thumbs]');
    if (thumbsWrap) thumbsWrap.innerHTML = '';
    this._setMediaLoading(true);
    this._showPlaceholderImage(triggerEl);

    this.popup.removeAttribute('hidden');
    this.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this._attachModalKeydown();
    var closeBtn = this.popup.querySelector('button[data-preview-close]');
    if (closeBtn) closeBtn.focus();

    this._loading = true;
    var url = this.getRoot() + '/products/' + encodeURIComponent(handle) + '.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('fetch');
        return r.json();
      })
      .then(function (prod) {
        self._loading = false;
        self._fillPreviewPanel(prod, null);
      })
      .catch(function () {
        self._loading = false;
        self._setMediaLoading(false);
        self._showPreviewError('Product could not be loaded.');
      });
  };

  ProductQuickView.prototype.init = function () {
    var self = this;
    this.popup.querySelectorAll('[data-preview-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        self.close();
      });
    });
    this.popup.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-preview-read-more]');
      if (!btn || !self.popup.contains(btn)) return;
      var desc = self.popup.querySelector('[data-preview-description]');
      if (!desc) return;
      var expanded = desc.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
  };

  var instance = null;

  function initSection(section) {
    if (!section || section.getAttribute('data-quickview-initialized') === 'true') return;
    section.setAttribute('data-quickview-initialized', 'true');
    instance = new ProductQuickView(section);
    window.BadassProductQuickView = instance;
  }

  function boot() {
    document.querySelectorAll('[data-product-quickview-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector && e.target.querySelector('[data-product-quickview-section]');
    if (section) initSection(section);
  });

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.badass-card__quickview-button[data-product-url]');
      if (!btn) return;
      if (!instance || !instance.popup) return;
      e.preventDefault();
      e.stopPropagation();
      instance.openFromUrl(btn.getAttribute('data-product-url'), btn);
    },
    true
  );
})();
